<template>
  <!--  BEGIN SIDEBAR  -->
  <div id="sidebar-global" class="sidebar-wrapper sidebar-theme">
    <!-- <img v-if="$store.state.menu_style == 'vertical'" src="@/assets/images/logo.png" alt="" style="width: 160px; margin: 24px" />
    <div v-else class="logo"></div> -->
    <nav ref="menu" id="sidebar">
      <!-- <div class="shadow-bottom"></div> -->

      <router-link v-for="(item, index) in menuConfig" tag="div" class="menu" :key="index" :to="item.path">
        <div class="menu-icon" :style="`background-image:url('${item.icon}')`">
          <div class="ground-glass">
            <img :src="item.icon" alt="" style="width: 50%; margin-top: 25%" />
          </div>
        </div>
        <div class="menu-name">{{ item.name }}</div>
      </router-link>

      <perfect-scrollbar class="list-unstyled menu-categories" tag="ul" :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
        <!-- 主页 -->
        <!-- <li class="menu">
          <a href="#dashboard" v-b-toggle class="dropdown-toggle" @click.prevent>
            <div class="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-home"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              <span>{{ $t('Dashboard') }}</span>
            </div>
            <svg-to-left></svg-to-left>
          </a>
          <b-collapse id="dashboard" accordion="menu">
            <ul class="collapse submenu list-unstyled show">
              <router-link tag="li" to="/" @click.native="toggleMobileMenu">
                <a>{{ $t('analysics') }}</a>
              </router-link>
              <router-link tag="li" to="/index2" @click.native="toggleMobileMenu">
                <a>{{ $t('sales') }}</a>
              </router-link>
            </ul>
          </b-collapse>
        </li> -->
        <!-- <div style="margin-top: 21px"></div> -->
        <li v-for="item in menu" :key="item.id" class="menu">
          <!-- <a v-if="item.type == 1" class="dropdown-toggle" @click.prevent="routeTo(item.path)">
            <div class="">
              <i v-if="item.icon" :data-feather="item.icon"></i>
              <span>{{ item.name }}</span>
            </div>
          </a> -->
          <router-link v-if="item.type == 1" tag="li" :to="'/' + item.path" class="menu" @click.native="toggleMobileMenu">
            <a class="dropdown-toggle">
              <div class="root-li">
                <i v-if="item.icon" :data-feather="item.icon"></i>
                <span>{{ $t(item.name) }}</span>
              </div>
            </a>
          </router-link>
          <a v-if="item.type == 0" :href="'#menu' + item.id" v-b-toggle class="dropdown-toggle" @click.prevent>
            <div class="">
              <i v-if="item.icon" :data-feather="item.icon"></i>
              <span>{{ $t(`menus.${item.path}`) }}</span>
            </div>
            <svg-to-left v-if="item.children && item.children.length"></svg-to-left>
          </a>
          <b-collapse v-if="item.type == 0 && item.children && item.children.length" :id="'menu' + item.id" accordion="menu">
            <ul class="collapse submenu list-unstyled show">
              <component
                v-for="child in item.children"
                :key="child.id"
                :is="getComponentName(child.type)"
                :data="child"
                :path="'/' + item.path + '/' + child.path"
                :toggleMobileMenu="toggleMobileMenu"
              ></component>

              <!-- <span v-for="child in item.children" :key="child.id">
                <router-link v-if="child.type == 1" tag="li" :to="'/' + item.path + '/' + child.path" @click.native="toggleMobileMenu">
                  <a>{{ child.name }}</a>
                </router-link>
                <li v-else-if="child.type == 0">
                  <a :href="'#menu' + child.id" v-b-toggle class="dropdown-toggle" @click.prevent>
                    {{ child.name }}
                  </a>
                  <b-collapse :id="'menu' + child.id">
                    <ul class="collapse list-unstyled sub-submenu show">
                      <router-link tag="li" to="/apps/invoice/list" @click.native="toggleMobileMenu"><a>List</a></router-link>
                    </ul>
                  </b-collapse>
                </li>
              </span> -->

              <!-- <router-link v-for="child in item.children" :key="child.id" tag="li" :to="'/' + item.path + '/' + child.path" @click.native="toggleMobileMenu">
                <a>{{ child.name }}</a>
              </router-link> -->
            </ul>
          </b-collapse>
        </li>
      </perfect-scrollbar>
    </nav>
    <!-- <a
      href="javascript:void(0);"
      class="sidebarCollapse"
      data-placement="bottom"
      @click="$store.commit('toggleMenuStyle', $store.state.menu_style == 'vertical' ? 'collapsible-vertical' : 'vertical')"
    >
      <img v-show="$store.state.is_show_sidebar" src="@/assets/images/layout/close.png" alt="" />
      <img v-show="!$store.state.is_show_sidebar" src="@/assets/images/layout/open.png" alt="" />
    </a> -->
  </div>
  <!--  END SIDEBAR  -->
</template>
<script>
import feather from 'feather-icons';
import { mapGetters } from 'vuex';
import svgToLeft from '../myComponent/svgToLeft.vue';
import childLi from './components/childLi.vue';
import childLink from './components/childLink.vue';
export default {
  components: {
    svgToLeft,
    childLi,
    childLink,
  },
  data() {
    return {
      menu_collapse: 'dashboard',
      currPath: '',
    };
  },
  computed: {
    ...mapGetters({
      menu: 'accountInfo/menu',
      account: 'accountInfo/account',
    }),
    menuConfig() {
      let menu = [
        {
          icon: require('@/assets/images/menu/menu1.svg'),
          name: '商品图',
          path: '/',
        },
        {
          icon: require('@/assets/images/menu/menu2.svg'),
          name: '我的素材',
          path: '/material',
        },
        {
          icon: require('@/assets/images/menu/menu3.svg'),
          name: '生成记录',
          path: '/record',
        },
      ];
      if (this.account.account && this.account.account.userType == 0) {
        menu = menu.concat({
          icon: require('@/assets/images/menu/menu4.svg'),
          name: '账号管理',
          path: '/account',
        });
      }
      return menu;
    },
  },
  watch: {
    $route(to) {
      const selector = document.querySelector('#sidebar a[href="' + to.path + '"]');
      if (!selector) return;
      const ul = selector.closest('ul.collapse');
      if (!ul) {
        const ele = document.querySelector('.dropdown-toggle.not-collapsed');
        if (ele) {
          ele.click();
        }
      }
    },
    menu() {
      this.$nextTick(() => {
        feather.replace();
      });
    },
    // '$store.state.dark_mode'(val) {
    //   // console.log(val);
    // },
  },
  mounted() {
    // default menu selection on refresh
    const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
    if (selector) {
      const ul = selector.closest('ul.collapse');
      if (ul) {
        let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
        if (ele) {
          ele = ele[0];
          setTimeout(() => {
            ele.click();
          });
        }
      } else {
        selector.click();
      }
    }
  },
  methods: {
    toggleMobileMenu() {
      if (window.innerWidth < 991) {
        this.$store.commit('toggleSideBar', !this.$store.state.is_show_sidebar);
      }
    },
    getComponentName(type) {
      return type == 0 ? 'child-li' : 'child-link';
    },
    routeTo(path) {
      this.$router.push({ path: '/' + path });
      this.currPath = path;
    },
  },
};
</script>

<style lang="scss">
$blue: #1089f9;
$grey: #f8fafb;
.sidebar-closed > #sidebar-global {
  left: -270px;
}
.collapsible-vertical {
  #sidebar-global {
    left: 28px;
    top: 80px;
    z-index: 1050;
    width: 80px;
    height: calc(100vh - 130px);
    background: linear-gradient(180deg, #181f26 0%, rgba(39, 39, 39, 0) 100%);
    border-radius: 16px;
    #sidebar {
      ul.menu-categories.ps {
        padding: 0 0 20px;
      }
    }
  }
}
#sidebar-global {
  left: 0;
  top: 0;
  border-radius: 0;
  background-color: #fff;
  #sidebar {
    display: flex;
    flex-direction: column;
    align-items: center;
    .active {
      .menu-icon .ground-glass {
        background: rgba(13, 17, 22, 0.7);
      }
      .menu-name {
        color: #9eff0c;
      }
    }
    .menu-icon {
      position: relative;
      width: 64px;
      height: 64px;
      margin-top: 8px;
      border-radius: 16px;
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: 50%;
      cursor: pointer;
      .ground-glass {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(13, 17, 22, 1);
        backdrop-filter: blur(10px) saturate(180%);
        -webkit-backdrop-filter: blur(10px) saturate(180%);
        text-align: center;
      }
    }
    .menu-name {
      margin: 5px 0 10px;
      color: #88929f;
      text-align: center;
      font-size: 12px;
    }
    ul.menu-categories {
      &.ps {
        height: calc(100vh - 135px) !important;
        padding: 0 0 16px;
      }
      li.menu {
        &.active > .dropdown-toggle {
          border-left: 4px solid $blue;
          border-radius: 0;
          background: $grey !important;
          color: $blue;
          .root-li {
            svg {
              color: $blue;
            }
            span {
              color: $blue;
            }
          }
        }
        .dropdown-toggle[aria-expanded='true']:not([data-active='true']) {
          background: rgba($color: #5e75fb, $alpha: 0.3);
          color: #0b132b;
        }
        // 一级
        > .dropdown-toggle {
          margin-top: 8px;
          margin-bottom: 0;
          border-left: 4px solid transparent;
          background-color: transparent;
          color: #88929f;
          // 一级悬浮
          &:hover {
            border-left: 4px solid $blue;
            border-radius: 0;
            background: $grey !important;
            color: $blue;
            svg {
              color: $blue;
              &.feather-chevron-right {
                display: block;
              }
            }
            .root-li span {
              color: $blue;
            }
          }
          // 一级选中
          &[aria-expanded='true']:not([data-active='true']) {
            border-left: 4px solid $blue;
            border-radius: 0;
            background: $grey !important;
            color: $blue;
            box-shadow: none;
            svg {
              color: $blue;
              fill: none;
            }
          }
          svg {
            color: #88929f;
          }
          .feather-chevron-right {
            display: none;
          }
          .root-li {
            svg {
              fill: none;
            }
            span {
              color: #88929f;
            }
          }
        }
        ul.submenu > li {
          // 二级选中
          &.active {
            a {
              color: $blue;
              background-color: $grey;
              &::before {
                display: block;
                background-color: $blue !important;
              }
            }
          }
          // 二级
          a {
            margin-left: 0;
            margin-top: 4px;
            padding-left: 40px;
            border-radius: 0;
            // 二级悬浮
            &:hover {
              background-color: $grey;
              color: $blue;
            }
            &::before {
              display: none;
              left: 30px;
            }
          }
        }
      }
      ul.submenu > li ul.sub-submenu > li {
        &.active {
          a {
            background-color: rgba($color: #5e75fb, $alpha: 0.1);
            color: #0b132b;
            &::before {
              display: block;
              background-color: #3bc171 !important;
            }
          }
        }
      }
    }
  }
}

.sidebarCollapse {
  position: absolute;
  left: 24px;
  bottom: 28px;
  height: 40px;
}

.logo {
  width: 20px;
  height: 20px;
  margin: 24px auto;
  background: url('~@/assets/images/logo-icon.png') no-repeat;
  background-size: contain;
}

.collapsible-vertical .sidebar-closed {
  > .sidebar-wrapper:hover {
    .logo {
      width: auto;
      margin-left: 24px;
      background-image: url('~@/assets/images/logo.png');
    }
  }
  .sidebarCollapse {
    left: 12px;
  }
}
</style>